import {
  Popup,
  TPopupComponent,
} from '../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { FC, useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TPopupDefaultActions } from '../../../../../../../../shared/components/popup/services/popup.service.ts';
import { ContentPopup } from './content.popup.tsx';
import { styled } from '@mui/material';
import { reimportArticlesFromCAState } from './states/reimportArticlesFromCA.state.ts';

export class ReimportArticlesFromCAPopup extends Popup<IReimportArticlesFromCAPopup> {
  Component: FC<TPopupComponent>;
  constructor() {
    super();
    const stream = this.innerStream;
    this.Component = () => {
      const SWrapper = useMemo(() => {
        return styled(this.Wrapper)(() => ({
          '& > div > div': { minWidth: 700, maxWidth: 700 },
        }));
      }, []);
      const { t } = useTranslation();

      useEffect(() => {
        stream.actionListener('close').subscribe(() => {
          reimportArticlesFromCAState.pub.clearState();
        });
      }, []);

      return (
        <SWrapper stream={stream} fullWidth popupTitle={t('settings.reimport_articles_from_ca')}>
          <ContentPopup {...{ stream }} />
        </SWrapper>
      );
    };
  }
}

export interface IReimportArticlesFromCAPopup {
  action: TPopupDefaultActions;
}
